module.exports = __webpack_public_path__ + "img/nature-45.0256c607.jpg";